import * as Stimulus from "@hotwired/stimulus"

export class RepeaterController extends Stimulus.Controller {
    static get targets() {
        return ["template", "container", "indicesField"];
    }
    static values = {
        id: Number,
        idPlaceholder: { type: String, default: "$id" }
    }

    addNewField() {
        let newNodes = this.templateTarget.content.cloneNode(true);
        this.#replaceIdsInTemplate(newNodes);
        this.containerTarget.append(newNodes);
        this.containerTarget.lastChild.focus();

        this.#addIndex(this.idValue);
        this.idValue++;

        queueMicrotask(() => {
            this.dispatch("change", { prefix: "", bubbles: true });
        });
    }

    deleteField(e) {
        this.#removeIndex(e.params.id);
        e.currentTarget.parentElement.remove();
        queueMicrotask(() => {
            this.dispatch("change", { prefix: "", bubbles: true });
        });
    }

    #replaceIdsInTemplate(fragment) {
        let nodes = Array.from(fragment.children);
        while (nodes.length > 0) {
            let currentNode = nodes.shift();
            if (currentNode.tagName === 'SVG') {
                continue;
            }

            for (let attribute of currentNode.attributes) {
                let oldValue = `${attribute.value}`
                let newValue = oldValue.replace(this.idPlaceholderValue, this.idValue);
                if (oldValue !== newValue) {
                    currentNode.setAttribute(attribute.name, newValue)
                }
            }
            nodes.push(...currentNode.children)
        }
    }

    #removeIndex(idValue) {
        let newIndices = this.#indices().filter(x => x != idValue);
        this.#setIndices(newIndices);
    }

    #addIndex(idValue) {
        let newIndices = this.#indices();
        newIndices.push(idValue);
        this.#setIndices(newIndices);
    }

    #indices() {
        return this.indicesFieldTarget.value.split(',').filter(x => x);
    }

    #setIndices(ids) {
        this.indicesFieldTarget.value = ids.join(',')
    }
}
